<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-fade">
  <p class="mb-0" style="color: white">Payment in progress...</p>
</ngx-spinner>
